export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img5-825a6198d42587d4ed08728de0226a59.jpg";